'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.extendObservableObj = exports.deepBind = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty4 = require('babel-runtime/helpers/defineProperty');

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _deepExtend = require('deep-extend');

var _deepExtend2 = _interopRequireDefault(_deepExtend);

var _deepBindDecorator = require('deep-bind-decorator');

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

var _extendObservableDecorator = require('extend-observable-decorator');

var _extendObservableDecorator2 = _interopRequireDefault(_extendObservableDecorator);

var _simboxEditable = require('simbox-editable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// import CollectionGridEditor from 'collection-grid-editor';

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var deepBind = exports.deepBind = _deepBindDecorator2.default;
var extendObservableObj = exports.extendObservableObj = _extendObservableDecorator2.default;

var BaseContentModel = (_dec = _mobx.action.bound, _dec2 = _mobx.observable.ref, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, (_class = (_temp = _class2 = function () {
  (0, _createClass3.default)(BaseContentModel, null, [{
    key: 'allEntities',

    // get all entities of this type
    value: function allEntities() {
      var _this = this;

      if (!this.$parent) throw new Error("$parent not attached.  this method is unavailable");
      // if allEntities is run from BaseContentModel ALL entities are returned
      return this === BaseContentModel ? this.$parent.entities.values() : this.$parent.entities.values().filter(function (ent) {
        return ent instanceof _this;
      });
    } // reference to parent contentModel, mainly to access the dictionary of all entities

  }]);

  // default editor
  function BaseContentModel() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _this2 = this;

    var app = arguments[1];
    var type = arguments[2];
    (0, _classCallCheck3.default)(this, BaseContentModel);
    this.Editor = _simboxEditable.DefaultEditor;
    this.type = null;
    this.shouldAutoPopulate = false;

    _initDefineProp(this, 'hasBrokenRefs', _descriptor, this);

    _initDefineProp(this, 'guid', _descriptor2, this);

    _initDefineProp(this, 'id', _descriptor3, this);

    _initDefineProp(this, '$inputStore', _descriptor4, this);

    _initDefineProp(this, 'willSave', _descriptor5, this);

    _initDefineProp(this, 'hasSaved', _descriptor6, this);

    _initDefineProp(this, 'willLoad', _descriptor7, this);

    _initDefineProp(this, 'hasLoaded', _descriptor8, this);

    _initDefineProp(this, '_cache', _descriptor9, this);

    this.type = type || json.type || this.constructor.name; //gets saved to simbox "tag"
    if (!this.type || this.type.charAt(0) === "_") throw new Error("please supply content model type! (classname) ");

    // a little bit of a hack, but only way to access unknown Editor on child classes
    require.ensure(["collection-grid-editor"], function () {
      if (!_this2.FullEditor) {
        if ((0, _keys2.default)(_this2.slots).some(function (k) {
          return Array.isArray(_this2.slots[k]);
        })) {
          _this2.FullEditor = require('collection-grid-editor').default;
        } else {
          _this2.FullEditor = _this2.Editor;
        }
      }
    });

    // @TODO USE GUIDS?
    this.id = json.id || this.constructor.id;
    delete json.id;

    if (this.savable === false || this.saveable === false || this.readonly) this.guid = "fake-id";

    // @TODO remove this
    delete json.isNew;

    (0, _assign2.default)(this, json);

    if (this.isNew) {
      if (this.shouldAutoPopulate) this.autoPopulate();
      if (this.addImmediately && !this.$parent.entities.get(this.id)) this.$parent.entities.set(this.id, this);
      this.constructor.newEntityWasAdded.set(+new Date());
    }

    setTimeout(function () {
      _this2._updateCache();
    }, 10);
  }

  (0, _createClass3.default)(BaseContentModel, [{
    key: '_updateCache',
    value: function _updateCache() {
      this._cache = this._serialized;
    }
  }, {
    key: 'getAllChildEntitiesFiltered',


    // fn takes childCm, parentCm, slotName 

    value: function getAllChildEntitiesFiltered(fn) {
      var _this3 = this;

      fn = fn || function () {
        return true;
      };
      var entities = new _set2.default();
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this3.slots[name]) ? _this3.slots[name][0] : _this3.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this3[name];
          if (value == null || typeof value === "string") return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            value.forEach(function (cm) {
              if (cm == null || typeof cm === "string" || fn(cm, _this3, name) === false) return acc;
              acc.add(cm);
              var moreChildren = cm.getAllChildEntitiesFiltered(fn);
              if (!moreChildren) debugger;
              moreChildren.forEach(function (child) {
                return acc.add(child);
              });
            });
          } else {
            // if(typeof value === "string")
            if (fn(value, _this3, name) === false) return acc;
            acc.add(value);
            var moreChildren = value.getAllChildEntitiesFiltered(fn);
            moreChildren.forEach(function (child) {
              return acc.add(child);
            });
          }
        }
        return acc;
      }, entities);
      return (0, _from2.default)(entities);
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (opts.forceBasicEditor) return this.Editor || _simboxEditable.DefaultEditor;
      // if getComponent is called with forceFullEditor, the FullEditor is loaded
      if (opts.forceFullEditor) return this.FullEditor || this.Component;
      // else the  Component is loaded first
      return this.Component || this.FullEditor;
    }
  }, {
    key: 'getContentModel',
    value: function getContentModel() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this;
    }
  }, {
    key: 'revert',
    value: function revert() {
      if (this.readonly) return;
      var reverted = void 0;
      try {
        reverted = JSON.parse(this._cache);
      } catch (e) {}
      reverted && this.populate(reverted);
    }
  }, {
    key: 'populate',
    value: function populate(json) {
      var _this4 = this;

      (0, _assign2.default)(this, json);
      var cm = this;
      (0, _keys2.default)(cm).forEach(function (k) {
        var slot = cm.slots[k];
        if (!slot || cm[k] == null || cm[k] instanceof BaseContentModel) return;
        if (cm[k].constructor && cm[k].constructor.name === "ObservableArray" && Array.isArray(slot)) {
          var spliceMe = [];
          cm[k].forEach(function (cmName, index) {
            if (cm[k][index] instanceof BaseContentModel) return;
            cm[k][index] = _this4.$parent.entities.get(cmName);
            if (cm[k][index] == null) {
              console.warn(cm.id + " has a broken reference in the " + k + " slot (" + cmName + " is missing from the system).  Saving of this entity will be disabled.");
              //@TODO figure out what to do with broken refs
              //cm.hasBrokenRefs = true;
              spliceMe.push(index);
            }
          });
          spliceMe.forEach(function (i, index) {
            return cm[k].splice(i - index, 1);
          });
        } else if (slot === BaseContentModel || slot.prototype instanceof BaseContentModel) {
          var ref = _this4.$parent.entities.get(cm[k]);
          if (!ref) {
            console.warn(cm.id + " has a broken reference in the " + k + " slot (" + cm[k] + " is missing from the system).  Saving of this entity will be disabled.");
            //@TODO figure out what to do with broken refs
            //cm.hasBrokenRefs = true;
          } else {
            cm[k] = ref;
          }
        }
      });
      this._updateCache();
    }
  }, {
    key: 'updateValue',
    value: function updateValue(prop, val) {
      if (this.isNew && prop === "id") {
        this.id = val;
        return;
      }
      if (!this.slots.hasOwnProperty(prop)) throw new Error("not editable property" + prop);
      var slot = this.slots[prop];
      if (Array.isArray(slot)) {
        // trying to write over an array
        throw new Error("do not update array directly... clear or push etc");
      } else if (slot && slot.prototype && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel) && !val) {
        // slot is a contentmodel and val is null
        this[prop] = null;
      } else if (slot && slot.prototype && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel) && typeof val === "string") {
        // slot is a contentmodel and string is name of a contentmodel
        var newContentModel = this.$parent.entities.get(val);
        if (!newContentModel) throw new Error("content model does not exist: " + val);
        this[prop] = newContentModel;
      } else if (slot === val.constructor) {
        // slot and val are of same contentmodel type
        this[prop] = val;
      } else if ((slot === BaseContentModel || slot.prototype instanceof BaseContentModel) && val.constructor.prototype instanceof BaseContentModel) {
        // slot is "any", and val is a contentmodel
        this[prop] = val;
      } else if (slot === "" || slot === "RichText" || slot === 0 || typeof slot === "boolean") {
        // slot is of a primitive type, or RichText
        this[prop] = val;
      } else {
        // say what?
        throw new Error("error with slot type" + prop);
      }
    }

    // content models should not handle user input

  }, {
    key: 'updateInput',
    value: function updateInput(prop, val) {
      console.warn("this method is soon to be deprecated");
      if (!this[prop].hasOwnProperty("value")) throw new Error("missing value property: " + prop);
      this[prop].value = val;
    }

    // we do not want people coming up with their own variable names

  }, {
    key: 'updateInputVariable',
    value: function updateInputVariable(prop, val) {
      console.warn("this method is soon to be deprecated");
      if (!this[prop].hasOwnProperty("variable")) throw new Error("missing variable property: " + prop);
      this[prop].variable = val;
    }
  }, {
    key: 'loadEntity',
    value: function loadEntity() {
      return this._loadEntity.apply(this, arguments);
    }
  }, {
    key: '_loadEntity',
    value: function _loadEntity(cb, errCb, extras) {
      var _this5 = this;

      if (this.isLoading || this.isNew) return cb && cb();
      if (!this.$parent) throw new Error("missing parent");
      if (!this.$parent.simgate) throw new Error("missing simgate");
      var simgate = this.$parent.simgate;
      if (this.readonly || this.savable === false || this.saveable === false) return cb && cb();

      this.willLoad = +new Date();

      var taskArgs = [simgate.execQuery, {
        "query": "simbox-queries://" + "getbyname",
        "parameters": { name: this.id }
      }, {
        onSuccess: function onSuccess(res) {
          var ent = res.data[0][0];
          _this5.$parent.hydrateEntities((0, _defineProperty5.default)({}, ent.name, ent));
          _this5.hasLoaded = +new Date();
          if (typeof cb === "function") cb(_this5);
        },
        onFailure: function onFailure(err) {
          debugger;
          errCb && errCb(err, _this5);
        }
      }];

      if (simgate.runTask) {
        simgate.runTask.apply(simgate, taskArgs);
      } else {
        simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }
    }
  }, {
    key: 'saveEntity',
    value: function saveEntity() {
      return this._saveEntity.apply(this, arguments);
    }
  }, {
    key: '_saveEntity',
    value: function _saveEntity(cb, errCb, extras) {
      var _this6 = this;

      // overwritten in local.js  
      if (this.hasBrokenRefs && !this.constructor.allowBrokenChildren) console.warn("this entity has broken refs.  Will not save: " + this.id);
      if (this.isSaving || !this.isDirty && !this.isNew || this.hasBrokenRefs && !this.constructor.allowBrokenChildren) return cb && cb();
      if (!this.$parent) throw new Error("missing parent");
      if (!this.$parent.simgate) throw new Error("missing simgate");
      var simgate = this.$parent.simgate;
      if (this.readonly || this.savable === false || this.saveable === false) return cb && cb();

      this.willSave = +new Date();

      var taskArgs = [simgate.execQuery, {
        "query": "simbox-queries://" + (this.isNew ? "insert" : "update"),
        "parameters": extras ? (0, _assign2.default)(this.simboxDTO, extras) : this.simboxDTO
      }, {
        onSuccess: function onSuccess(res) {
          _this6._updateCache();
          // this.isNew = false;
          // @TODO after save needs to return guid, put it here
          _this6.guid = "fake-id";
          _this6.hasSaved = +new Date();
          _this6._lastReview = res.data[0][0][""];

          //add to parent entities content model if doesnt exist
          if (!_this6.$parent) debugger;
          if (!_this6.$parent.entities.get(_this6.id)) _this6.$parent.entities.set(_this6.id, _this6);

          if (typeof cb === "function") cb(_this6);
        },
        onFailure: errCb,
        onRetry: function onRetry(err) {
          if (err.message.indexOf("#3.14159") === 0) {
            _this6.willSave = 0;
            window.application.modalViewStore.setModal({
              title: "Content out of date!",
              message: _react2.default.createElement(
                'div',
                { style: { maxWidth: "500px" } },
                'The content for ',
                _this6.uniqueDisplayName,
                ' is out of date.  Saving is restricted until you have the latest copy.  Please click \'Update Now\' to revert the content to the latest version.  WARNING: You WILL lose your new content during this process, here it is for reference purposes: ',
                _react2.default.createElement(
                  'pre',
                  null,
                  (0, _stringify2.default)(JSON.parse(_this6._serialized), null, 2)
                )
              ),
              confirmLabel: 'Update Now',
              confirmBtnClass: 'green check-a',
              cancelLabel: 'Cancel',
              cancelBtnClass: 'red times-b',
              onConfirmFunc: function onConfirmFunc() {
                _this6.loadEntity(function () {
                  _this6.hasSaved = +new Date();
                  window.application.modalViewStore.resetModal();
                });
              }
            });
            return false;
          }
        }
      }];

      if (simgate.runTask) {
        simgate.runTask.apply(simgate, taskArgs);
      } else {
        simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }

      return this;
    }
  }, {
    key: 'deleteEntity',
    value: function deleteEntity(cb, errCb) {
      var _this7 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var modalViewStore = window.application.modalViewStore;

      var toBeRemovedFrom = false;
      var itemsToSearch = this.containedBy;
      if (itemsToSearch.length) {
        toBeRemovedFrom = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'b',
            null,
            'Warning!'
          ),
          ' This item will be permanently removed from:',
          _react2.default.createElement('br', null),
          itemsToSearch.map(function (it) {
            return _react2.default.createElement(
              'div',
              { key: it.id },
              it.uniqueDisplayName,
              ' ( ',
              it.type,
              ' )'
            );
          })
        );
      }

      modalViewStore.setModal({
        title: "Remove " + this.uniqueDisplayName,
        message: _react2.default.createElement(
          'div',
          null,
          'Permanently remove ',
          this.uniqueDisplayName,
          ' from the system? ',
          toBeRemovedFrom
        ),
        confirmLabel: 'Permanently Delete',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          if (typeof options.onConfirmImmediate === "function") options.onConfirmImmediate(_this7);
          if (itemsToSearch && itemsToSearch.length) {
            //search through all items in containedBy and set them to null
            for (var i = 0; i < itemsToSearch.length; i++) {
              var item = itemsToSearch[i],
                  hasSlots = item.slots;

              for (var key in hasSlots) {
                if ((0, _typeof3.default)(hasSlots[key]) === 'object') {
                  //object or mobx array
                  if (Array.isArray(hasSlots[key].slice()) && hasSlots[key][0] === _this7.constructor) {
                    //is array and the same type
                    //we found the key that it belongs to so loop through this object and delete the item from it
                    for (var _i = 0; _i < item[key].length; _i++) {
                      var oItem = item[key][_i];
                      if (oItem.id === _this7.id) {
                        oItem = null;
                        item[key].splice(_i, 1);
                        item.saveEntity();
                        break;
                      }
                    }
                    break;
                  } else if (hasSlots[key] === _this7.constructor && hasSlots[key].id === _this7.id) {
                    //is actual object
                    hasSlots[key] = null;
                    item.saveEntity();
                    break;
                  }
                }
              }
            }
          }

          _this7._deleteEntity(function () {
            modalViewStore.resetModal();
            if (typeof cb === "function") cb();
          }, errCb, options);
        }
      });
    }
  }, {
    key: '_deleteEntity',
    value: function _deleteEntity(cb, errCb, extras) {
      var _this8 = this;

      // if(this.isSaving || (!this.isDirty && !this.isNew)) return cb && cb()
      if (!this.$parent) throw new Error("missing parent");
      if (!this.$parent.simgate) throw new Error("missing simgate");
      var simgate = this.$parent.simgate;
      // if(this.readonly || this.savable === false || this.saveable === false) return cb && cb()

      // this.willSave = +new Date;
      var params = {
        // this.id gets saved to name
        name: this.id
      };

      var taskArgs = [simgate.execQuery, {
        "query": "simbox-queries://deletebyname",
        "parameters": params
      }, {
        onSuccess: function onSuccess(res) {
          _this8.$parent.entities.delete(_this8.id);
          if (typeof cb === "function") cb(_this8, res);
        },
        onFailure: function onFailure(err) {
          // debugger
          console.error(err);
          errCb && errCb(err, _this8);
        }
      }];

      if (simgate.runTask) {
        simgate.runTask.apply(simgate, taskArgs);
      } else {
        simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }

      return this;
    }
  }, {
    key: 'handleUnsavedChanges',
    value: function handleUnsavedChanges(cb, cancelCb, options) {
      var _this9 = this;

      window.application.modalViewStore.setModal({
        title: "Unsaved Changes",
        message: "You have unsaved changes in " + this.uniqueDisplayName + ".  If you continue you will lose these changes!  Press cancel to go back.",
        confirmLabel: 'Revert and Continue',
        confirmBtnClass: 'green check-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          window.application.modalViewStore.resetModal();
          _this9.revert();
          if (typeof cb === "function") cb(_this9);
        }
      });
    }
  }, {
    key: 'cloneEntity',
    value: function cloneEntity() {
      return window.application.modalViewStore.setModal({
        title: "Clone " + this.uniqueDisplayName,
        message: "Cloning entities is not yet supported.",
        confirmLabel: "Continue",
        confirmBtnClass: 'green'
      });

      //@TODO move modalViewStore access to this.$parent (global contentModel)?
      window.application.modalViewStore.setModal({
        title: "Clone " + this.uniqueDisplayName,
        message: !this.allClonableChildren.length ? "Would you like to clone " + this.uniqueDisplayName + "?" : _react2.default.createElement(
          'div',
          { style: { maxWidth: "500px" } },
          'This entity has ',
          this.allClonableChildren.length,
          ' nested children.  Would you like to do a deep (clone all children) or shallow (keep original children) clone? ',
          _react2.default.createElement(
            'select',
            { id: 'cloneDeepOrShallow' },
            _react2.default.createElement(
              'option',
              null,
              'deep'
            ),
            _react2.default.createElement(
              'option',
              null,
              'shallow'
            )
          )
        ),
        confirmLabel: 'Clone',
        confirmBtnClass: 'green check-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          var select = document.getElementById("cloneDeepOrShallow");
          alert(select.value);
        }
      });
    }
  }, {
    key: 'autoPopulate',
    value: function autoPopulate() {
      var _this10 = this;

      var autopop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var autoPopulate = (0, _keys2.default)(this.slots);
      autoPopulate.forEach(function (name) {
        if (!_this10.slots.hasOwnProperty(name)) throw new Error("contentmodel missing slot: " + name);
        var num = getRandomIntInclusive(0, 1000);
        var slot = _this10.slots[name];
        var ContentModel = void 0;
        //@TODO __proto__ hack accounts for mock extension to match basecontentmodel also...
        if (slot === BaseContentModel || process && process.env && process.env.localMode && slot.__proto__ === BaseContentModel) {
          if (!autopop[name] || !(autopop[name] instanceof BaseContentModel)) console.warn("no autopopulation class indicated for this `any` slot: " + name);
          _this10[name] = null;
          return;
        } else {
          if (!(slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) return;
          ContentModel = slot;
        }
        _this10[name] = new ContentModel({ id: ContentModel.name.replace("ContentModel", "") + "_" + num });
      });
    }
  }, {
    key: 'hasBrokenChildren',
    get: function get() {
      //@TODO need to figure out what to do with broken refs
      return false; //this.hasBrokenRefs || this.allChildEntities.some( ent => !!ent.hasBrokenChildren )
    }
  }, {
    key: 'isNew',
    get: function get() {
      return !this.guid;
    }
  }, {
    key: 'isSaving',
    get: function get() {
      return this.willSave - this.hasSaved > 0;
    }
  }, {
    key: 'isLoading',
    get: function get() {
      return this.willLoad - this.hasLoaded > 0;
    }
  }, {
    key: 'slots',
    get: function get() {
      if (!this.constructor._slots) throw new Error("contentmodel is missing slots");
      return this.constructor._slots;
    }
  }, {
    key: '$parent',
    get: function get() {
      return this.constructor.$parent;
    }
  }, {
    key: 'meta',
    get: function get() {
      return this.constructor._meta;
    }
  }, {
    key: 'allOfSameType',
    get: function get() {
      return this.constructor.allEntities();
    }
  }, {
    key: 'hasCollection',
    get: function get() {
      var _this11 = this;

      return (0, _keys2.default)(this.slots).some(function (k) {
        return Array.isArray(_this11.slots[k]);
      });
    }
  }, {
    key: 'containedBy',
    get: function get() {
      var _this12 = this;

      return this.$parent.entities.values().filter(function (e) {
        return !e.constructor.Synthetic && e.immediateChildren.indexOf(_this12) > -1;
      });
    }
  }, {
    key: 'uniqueDisplayName',
    get: function get() {
      return this.hasDuplicateDisplayName ? this.displayName + " (" + this.id + ")" : this.displayName || this.id;
    }
  }, {
    key: 'idOrDisplayName',
    get: function get() {
      return this.displayName ? this.displayName + " (" + this.id + ")" : this.id;
    }
  }, {
    key: 'hasDuplicateDisplayName',
    get: function get() {
      var _this13 = this;

      return this.displayName && this.$parent.entities.values().some(function (ent) {
        return ent !== _this13 && ent.displayName === _this13.displayName;
      });
    }
    // @TODO causes cycles
    // @computed get containedByProject(){
    //   return this.$parent.entities.get("Project").allChildEntities.some( e => e === this );
    // }

  }, {
    key: 'isOrphan',
    get: function get() {
      return this.containedBy.length === 0;
      // return this.containedByProject.length === 0;
    }
  }, {
    key: 'isAvailable',
    get: function get() {
      var _this14 = this;

      var maxParents = this.constructor.maxParents;
      if (!maxParents) return true;
      var count = 0;
      var typeCm = this.$parent.entities.get(maxParents[0]);
      var exceedsMaxParents = typeCm.entities.some(function (e) {
        if (e.immediateChildren.indexOf(_this14) > -1) count++;
        if (count >= maxParents[1]) return true;
      });
      return !exceedsMaxParents;
    }
  }, {
    key: 'allChildEntities',
    get: function get() {
      var _this15 = this;

      var entities = new _set2.default();
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this15.slots[name]) ? _this15.slots[name][0] : _this15.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this15[name];
          if (value == null || typeof value === "string") return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            value.forEach(function (cm) {
              if (cm == null || typeof cm === "string") return acc;
              acc.add(cm);
              var moreChildren = cm.allChildEntities;
              if (!moreChildren) debugger;
              moreChildren.forEach(function (child) {
                return acc.add(child);
              });
            });
          } else {
            // if(typeof value === "string")
            acc.add(value);
            var moreChildren = value.allChildEntities;
            moreChildren.forEach(function (child) {
              return acc.add(child);
            });
          }
        }
        return acc;
      }, entities);
      return (0, _from2.default)(entities);
    }
  }, {
    key: 'allClonableChildren',
    get: function get() {
      return this.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        return childCm.clonable === false || childCm.constructor.clonable === false;
      });
    }
  }, {
    key: 'allChildCms',
    get: function get() {
      var _this16 = this;

      var entities = [];
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this16.slots[name]) ? _this16.slots[name][0] : _this16.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this16[name];
          if (value == null) return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            // ignoring arrays
            // value.forEach( cm => {
            //   acc.push( [cm,value] );
            //   const moreChildren = cm.allChildCms;
            //   moreChildren.forEach( child => acc.push( child ) )
            // })
          } else if (value instanceof BaseContentModel) {
            acc.push([value, _this16, name]);
            var moreChildren = value.allChildCms;
            if (!moreChildren) debugger;
            moreChildren.forEach(function (child) {
              return acc.push(child);
            });
          }
        }
        return acc;
      }, entities);
      return entities;
    }
  }, {
    key: 'immediateChildren',
    get: function get() {
      var _this17 = this;

      var entities = [];
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this17.slots[name]) ? _this17.slots[name][0] : _this17.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this17[name];
          if (value == null) return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            value.forEach(function (cm) {
              acc.push(cm);
            });
          } else if (value instanceof BaseContentModel) {
            acc.push(value);
          }
        }
        return acc;
      }, entities);
      return entities;
    }
  }, {
    key: 'allCms',
    get: function get() {
      var _this18 = this;

      var entities = [];
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this18.slots[name]) ? _this18.slots[name][0] : _this18.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this18[name];
          if (typeof value === "string") {
            console.warn("improper slot, value combo", _this18.id);
            return acc;
          }
          if (value == null) return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            // ignoring arrays
            // value.forEach( cm => {
            //   acc.push( [cm,value] );
            //   const moreChildren = cm.allChildCms;
            //   moreChildren.forEach( child => acc.push( child ) )
            // })
          } else {
            var moreChildren = value.allChildCms;
            moreChildren.forEach(function (child) {
              return acc.push(child);
            });
          }
        }
        return acc;
      }, entities);
      return entities;
    }
  }, {
    key: '_serialized',
    get: function get() {
      var _this19 = this;

      if (this.readonly || this.constructor.readonly || !this.constructor._slots) return "";
      var ret = (0, _stringify2.default)((0, _mobx.toJS)((0, _keys2.default)(this.slots).reduce(function (acc, k) {
        if (Array.isArray(_this19.slots[k])) {
          // if(!this[k]) debugger
          acc[k] = _this19[k].filter(function (i) {
            return i != null;
          }).map(function (i) {
            return i.id;
          });
        } else if (_this19[k] instanceof BaseContentModel) {
          acc[k] = _this19[k].id;
        } else if (_this19.slots[k] === "Array") {
          acc[k] = _this19[k].slice();
        } else {
          acc[k] = _this19[k];
        }
        return acc;
      }, { id: this.id })));
      return ret;
    }
  }, {
    key: 'isDirty',
    get: function get() {
      var dirty = this._serialized !== this._cache;
      return dirty;
    }
  }, {
    key: 'anyDirty',
    get: function get() {
      //@TODO circular references...
      return this.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        return childCm.savable !== false && childCm.constructor.savable !== false && childCm.Synthetic !== true && childCm.constructor.Synthetic !== true;
      }).some(function (ent) {
        return ent.isDirty;
      });
    }
  }, {
    key: 'allEntities',
    get: function get() {
      return [this].concat((0, _toConsumableArray3.default)(this.allChildEntities));
    }
  }, {
    key: '_invalid',
    get: function get() {
      var _invalid = {};
      if (this.isNew) {
        if (!!this.$parent.entities.get(this.id)) {
          _invalid.id = "An entity with this id (" + this.id + ") already exists.  Please choose a different id.";
        }
      }

      if (!this.id) _invalid.id = "Please provide an id!";

      if (this.hasBrokenRefs) _invalid.hasBrokenRefs = "This entity has broken references and will not be savable.";

      return _invalid;
    }
    // please overwrite me :-)

  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      // add other validations
      return invalid;
    }
  }, {
    key: 'isInvalid',
    get: function get() {
      return !!(0, _keys2.default)(this.invalid).length;
    }
  }, {
    key: 'allowSave',
    get: function get() {
      return !(0, _keys2.default)(this.invalid).length && (this.isNew || this.isDirty);
    }
  }, {
    key: '_inputs',
    get: function get() {
      var _this20 = this;

      return (0, _keys2.default)(this).filter(function (k) {
        return (0, _keys2.default)(_this20.slots).indexOf(k) === -1 && (0, _mobx.isObservable)(_this20, k) && (0, _typeof3.default)(_this20.$mobx.target[k]) === "object" && (0, _mobx.isObservable)(_this20[k], "variable") && (0, _mobx.isComputed)(_this20[k], "variable");
      }).reduce(function (acc, k) {
        if ((0, _mobx.isObservable)(_this20[k], "value") && (0, _mobx.isComputed)(_this20[k], "value")) {
          (0, _defineProperty3.default)(acc, _this20[k].variable, {
            enumerable: true,
            get: function () {
              return this[k].value;
            }.bind(_this20)
          });
          return acc;
        }
        acc[_this20[k].variable] = _this20[k].defaultValue || null;
        return acc;
      }, {});
    }
  }, {
    key: 'simboxDTO',
    get: function get() {
      var params = {
        // this.id gets saved to name
        name: this.id,
        // this._serialized gets saved to attr1
        attr1: this._serialized,
        review: this._lastReview || 0,
        val: this._lastReview || 0,
        tag: this.type
        // this.type gets saved to tag, but only if new
      };if (this.isNew) params.tag = this.type;
      return params;
    }
  }]);
  return BaseContentModel;
}(), _class2.newEntityWasAdded = (0, _mobx.observable)(0), _class2.$parent = null, _temp), (_applyDecoratedDescriptor(_class.prototype, '_updateCache', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_updateCache'), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, 'hasBrokenRefs', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'hasBrokenChildren', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasBrokenChildren'), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'guid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isNew', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isNew'), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, '$inputStore', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'willSave', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'hasSaved', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isSaving', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isSaving'), _class.prototype), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'willLoad', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'hasLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isLoading', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isLoading'), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, '_cache', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, 'slots', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'slots'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '$parent', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '$parent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'meta', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'meta'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allOfSameType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allOfSameType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasCollection'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'containedBy', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'containedBy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'uniqueDisplayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'uniqueDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'idOrDisplayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'idOrDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasDuplicateDisplayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasDuplicateDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isOrphan', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isOrphan'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isAvailable', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isAvailable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allChildEntities', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allChildEntities'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allClonableChildren', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allClonableChildren'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allChildCms', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allChildCms'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'immediateChildren', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'immediateChildren'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allCms', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allCms'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_serialized', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_serialized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'anyDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'anyDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allEntities', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allEntities'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isInvalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isInvalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allowSave', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allowSave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_inputs', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_inputs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'revert', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'revert'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'populate', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateValue', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateInput', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateInput'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateInputVariable', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateInputVariable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadEntity', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loadEntity', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_loadEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveEntity', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'simboxDTO', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'simboxDTO'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_saveEntity', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_saveEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteEntity', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_deleteEntity', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_deleteEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleUnsavedChanges', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleUnsavedChanges'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cloneEntity', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cloneEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'autoPopulate', [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'autoPopulate'), _class.prototype)), _class));
exports.default = BaseContentModel;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getRandomIntInclusive, 'getRandomIntInclusive', 'src/core_modules/base-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(deepBind, 'deepBind', 'src/core_modules/base-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(extendObservableObj, 'extendObservableObj', 'src/core_modules/base-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(BaseContentModel, 'BaseContentModel', 'src/core_modules/base-contentmodel/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js
// module chunks = 0